import { ProjectSharing } from "components/ProjectSharing/ProjectSharing";
import { useProjectDataContext } from "pages/project/ProjectDataProvider";

export const ProjectTabAccess = () => {
  const { project } = useProjectDataContext();
  return <ProjectSharing projectId={project.id} mode="flex" />;
};
